import { RJSFSchema } from '@rjsf/utils'
import { type Descriptor, type UiSchemaDescriptor } from '../../../../../models/Scorecard'
import { getFormFieldTypeFromDescriptor } from '../../../../../views/Setup/FormTemplates/utils'

export const mapFormResultValueToString = (value: unknown): string => {
  if (value === null || value === undefined) {
    return ''
  }

  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }

  if (Array.isArray(value)) {
    return value.map(mapFormResultValueToString).join(', ')
  }

  if (typeof value === 'object') {
    return Object.entries(value)
      .map(([key, innerValue]) => `${key}: ${mapFormResultValueToString(innerValue)}`)
      .join(', ')
  }

  return String(value)
}

export const formatPropertyLabel = (key: string): string => {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (s) => s.toUpperCase())
    .trim()
}

export const escapeFormResultCsvValue = (value: string): string => {
  if (value.includes(',') || value.includes('\n')) {
    return `"${value}"`
  }

  if (value.includes('"')) {
    return `"${value.replace(/"/g, '""')}"`
  }

  return value
}

const isMultipleChoiceFormField = (schema: RJSFSchema, uiSchema?: UiSchemaDescriptor): boolean => {
  if (getFormFieldTypeFromDescriptor(schema as Descriptor, uiSchema) === 'multipleChoice') {
    return true
  }

  // Older scorecards may omit customWidgets while still using enum-backed multi-select fields.
  return schema.type === 'array' && Array.isArray((schema.items as { enum?: unknown[] } | undefined)?.enum)
}

/** List/table array fields render Explain/Source beside the field block in read view. Multi-select comboboxes render it inside the gray bar. */
export const usesExternalCitationInReadView = (schema: RJSFSchema, uiSchema: UiSchemaDescriptor | undefined, isEditing: boolean): boolean => {
  if (isEditing || schema.type !== 'array') {
    return false
  }

  return !isMultipleChoiceFormField(schema, uiSchema)
}
